// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__2sR_u","logo":"MainNavigation_logo__3xtIl","nav":"MainNavigation_nav__2fhsH","active":"MainNavigation_active__1a5F-"};